import { useTranslation } from 'react-i18next';

export const ProductEbookNote = () => {
  const { t } = useTranslation();

  return (
    <p className="product__ebook-note">
      {t('cart.productList.ebookNote')}
    </p>
  );
};
